module.exports = __webpack_public_path__ + "img/down-arrow.473a55ca.svg";